<template>
  <section class="max-w-lg mx-auto">
    <div
      v-if="form.errors.has('documents')"
      class="card text-center bg-red text-white mx-auto p-4 mb-6"
      v-text="form.errors.get('documents')"
    />
    <fieldset>
      <legend
        class="fieldset-legend"
        v-text="'Attach Document(s)'"
      />
      <BaseDropzone
        id="dropzone"
        ref="dropzone"
        class="mt-4"
        :options="dropzoneOptions"
        @dropzone-error="uploadHasErrored"
        @dropzone-complete="fileHasBeenUploaded"
        @dropzone-file-added="form.filesInQueue++"
        @dropzone-removed-file="form.filesInQueue--"
        @dropzone-queue-complete="uploadHasCompleted"
      />
    </fieldset>
    <div class="text-center mt-6">
      <button
        type="button"
        class="btn"
        @click="$emit('nextClicked')"
        v-text="'Next'"
      />
    </div>
    <fieldset
      v-if="form.existingDocuments.length"
      class="mt-6"
    >
      <legend
        class="fieldset-legend"
        v-text="'Attached Document(s)'"
      />
      <div class="table-responsive">
        <table
          class="table table-files min-w-table"
          style="min-height: auto;"
        >
          <colgroup>
            <col>
            <col>
            <col width="20%">
          </colgroup>
          <thead>
            <tr>
              <th v-text="'Title'" />
              <th />
              <th v-text="'Remove'" />
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="existingDocument in form.existingDocuments"
              :key="existingDocument.uuid"
              :class="{ 'bg-grey-light': existingDocument.doomed }"
            >
              <td v-text="existingDocument.attributes.title" />
              <td>
                <span
                  v-if="existingDocument.doomed"
                  class="text-red"
                  v-text="'Marked for removal upon save!'"
                />
              </td>
              <td class="pr-4">
                <button
                  v-if="!existingDocument.doomed"
                  type="button"
                  class="btn btn--sm btn--danger"
                  @click="addExistingDocumentToRemovalQueue(existingDocument)"
                  v-text="'Remove'"
                />
                <button
                  v-else
                  type="button"
                  class="btn btn--sm btn--border"
                  @click="removeExistingDocumentFromRemovalQueue(existingDocument)"
                  v-text="'Undo'"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </fieldset>
  </section>
</template>

<script type="text/babel">
import UploadDocument from '../mixins/UploadDocumentMixin'

export default {
  name: 'DocumentPane',
  mixins: [UploadDocument],
  props: {
    value: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    dropzoneOptions() {
      return {
        url: this.$urlGenerator.active(),
        autoProcessQueue: false,
        maxFiles: 15,
        maxFilesize: 1500,
        parallelUploads: 1,
        acceptedFiles: 'image/*,.pdf,.doc,.docx,.pages,.numbers,.xls,.ppt,.txt,.xml,.csv,.svg',
        dictDefaultMessage: 'Click or drag files here...',
      }
    },
    form: {
      get() {
        return this.value
      },
      set(form) {
        this.$emit('input', form)
      },
    },
  },
  methods: {
    fileHasBeenUploaded() {
      if (this.form.totalUploadCount > this.form.currentUploadCount) {
        this.form.currentUploadCount++
      }
    },
    uploadHasErrored() {
      this.form.uploadingDocuments = false

      this.form.setErrors({
        message: 'The given data was invalid',
        errors: {
          documents: [
            'There was a problem uploading document(s).',
          ],
        },
      })

      this.$emit('uploadHasErrored')
    },
    addExistingDocumentToRemovalQueue(existingDocument) {
      this.$set(existingDocument, 'doomed', true)

      this.form.documentsToRemove.push(existingDocument.uuid)
    },
    removeExistingDocumentFromRemovalQueue(existingDocument) {
      this.form.documentsToRemove.splice(this.form.documentsToRemove.indexOf(existingDocument.uuid), 1)

      existingDocument.doomed = false
    },
  },
}
</script>
